import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Card, Col, Row, Button } from "react-bootstrap";
import { removeAvailableHoursNote } from "../../../../redux/actions/AvailableHoursActions";
import EditNoteModal from "./EditNoteModal";

function Note({ note, deleteNote }) {
  const remove = () => deleteNote(note);

  return (
    <Row>
      <Col xs="12">
        <Card>
          <Card.Body>
            <Card.Header>
              <Row>
                <Col>
                  <strong>
                    {note.addedBy} | {note.addedOn}
                  </strong>
                </Col>
                <Col xs="auto">
                  <Button onClick={remove}>Delete</Button>
                </Col>
              </Row>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col>{note.text}</Col>
                <Col xs="auto">
                  <EditNoteModal note={note} />
                </Col>
              </Row>
            </Card.Body>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}

Note.propTypes = {
  note: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {};
}

const mapDispatchToProps = {
  deleteNote: removeAvailableHoursNote,
};

export default connect(mapStateToProps, mapDispatchToProps)(Note);
